import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { PageGuardPamong } from 'app/KinerjaPamongPage/components/PageGuardPamong'
import { AjukanPerencanaan } from 'app/KinerjaPamongPage/pages/pegawai/perencanaan/AjukanPerencanaan'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { GetServerSidePropsResult, NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ): Promise<GetServerSidePropsResult<{}>> => {
    const isKinerjaSpnfEnabled = toggle?.['kinerja-spnf-enabled'] || false
    if (!isKinerjaSpnfEnabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

export default function Page() {
  return (
    <PageGuardPamong>
      <AjukanPerencanaan />
    </PageGuardPamong>
  )
}

Page.Layout = KinerjaLayout
